import React from "react";
import "./AddActivity.css";
import { Link } from "react-router-dom";

function AddActivity() {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center addActivity_main">
        <div className="d-flex flex-column align-items-center">
          <h3 className="m-0">Add Activity</h3>
          <div className="sub-text-Activity">
          No content here yet, click below button to add activity materials.
          </div>

          <Link to="/CreateActivity">
          <button id="addPreReadBtn"><img src="/ContentM_images/addButton.svg"/> Add </button>
          </Link>
        </div>
      </div>
    </>
  );
}

export default AddActivity;
